import NativeAd from './nativeAd';
import NativeAdSmall from './nativeAdSmall';

export {
  NativeAd,
  NativeAdSmall
}
